import { render, staticRenderFns } from "./MyEditor.vue?vue&type=template&id=7f4bf6fe&scoped=true"
import script from "./MyEditor.vue?vue&type=script&lang=js"
export * from "./MyEditor.vue?vue&type=script&lang=js"
import style0 from "./MyEditor.vue?vue&type=style&index=0&id=7f4bf6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4bf6fe",
  null
  
)

export default component.exports